<template>
  <div class="details-download-list">
    <div class="download-list">
      <div v-for="row in list" :key="row.id" class="download-list-item">
        <h3 class="item-list-title">{{row.categoryName}}</h3>
        <template v-if="row.categoryType==='file'">
          <ul class="file-list">
            <li v-for="item in row.fileItems" :key="item.id">
              <span class="file-link" @click.stop="handleDownload(item)">{{item.fileName}}</span>
            </li>
          </ul>
        </template>

        <template v-else>
          <ul class="pic-video-list">
            <li v-for="item in row.fileItems" :key="item.id">
              <div class="pic-model" @click.stop="handlePreviewOpen(item)">
                <img class="pic" :src="getPictureUrl(item)"/>
                <img v-if="item.videoBgImageUrl" class="pic-play-btn" :src="playBtnPic"/>
              </div>
              <div class="file-link" @click.stop="handleDownload(item)">{{item.fileName}}</div>
            </li>
          </ul>
        </template>
      </div>
    </div>

    <preview-layer v-if="picPreviewShow" @close="picPreviewShow=false">
      <template slot="context">
        <img class="pic" :src="currentUrl"/>
      </template>
    </preview-layer>

    <preview-layer v-if="videoPreviewShow" @close="videoPreviewShow=false">
      <template slot="context">
        <video controls
               controlsList="nodownload"
               ref="downloadVideo"
               playsinline
               x-webkit-airplay
               x5-video-player-type="h5"
               x5-videoplayer-fullscreen
               webkit-playsinline
               :src="currentUrl"
               :poster="currentPoster"
               x5-video-orientation='portraint'
               style='object-fit:fill;'
               width='375px'
               height='211px'></video>
      </template>
    </preview-layer>

    <message-box v-if="registerSuccessMsgShow" @close="registerSuccessMsgShow=false">
      <template slot="context">注册待审中<br/>我们将尽快审核您的申请，<br/>并告诉您审核结果</template>
    </message-box>
  </div>
</template>

<script>
import {isWechatBrowser,downloadUrlFile} from "@/utilities/tools";
import PreviewLayer from "./PreviewLayer";
import MessageBox from "../../components/MediaCenter/MessageBox";
export default {
  name: "DetailsDownloadList",
  components: {PreviewLayer,MessageBox},
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      picPreviewShow: false,
      videoPreviewShow: false,
      currentUrl: null,
      currentPoster: null,
      playBtnPic: require("@/assets/MediaCenter/playBtn.png"),
      registerSuccessMsgShow: false
    }
  },
  methods: {
    handleDownload({fileUrl, fileName, isAllowDownload}){
      if(localStorage.getItem('dUserToken')) {
        if(!isAllowDownload) {
          this.registerSuccessMsgShow = true;
          return;
        }
      } else {
        const redirectUrl = encodeURIComponent(this.$route.path);
        this.$router.push("/Rccl.CustomPage/MediaCenter/MediaLogin?redirectUrl="+redirectUrl);
        return;
      }
      if(!isWechatBrowser()) {
        downloadUrlFile(fileUrl, fileName, this.$loading);
      }
    },
    getPictureUrl({reviewImageUrl, videoBgImageUrl}) {
      let imgUrl = null;
      if(reviewImageUrl) {
        imgUrl = reviewImageUrl;
      } else if(videoBgImageUrl) {
        imgUrl = videoBgImageUrl;
      } else {
        imgUrl = null;
      }
      return imgUrl;
    },
    handlePreviewOpen({reviewImageUrl, videoBgImageUrl, videoLink}) {
      if(reviewImageUrl) {
        this.currentUrl = reviewImageUrl;
        this.picPreviewShow = true;
      } else if(videoBgImageUrl) {
        this.currentPoster = videoBgImageUrl;
        this.currentUrl = videoLink;
        this.videoPreviewShow = true;
      } else {
        this.currentUrl = null;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.details-download-list {
  width: 327px;
  margin: 20px auto 0;
  padding-bottom: 20px;
  border-top: 1px solid #EEEEEE;
  & .download-list-item {
    margin-top: 20px;
    & .item-list-title {
      width: 327px;
      margin: 0 auto;
      font-size: .8rem;
      
      color: #02168f;
    }
  }
  & .file-link {
    width: 100%;
    font-size: .65rem;
    line-height: 1.2;
    text-decoration: underline;
    color: #555a6e;
  }

  & .file-list {
    margin: 6px auto 0;
    & > li {
      padding: 4px 0;
    }
  }

  & .pic-video-list {
    display: grid;
    grid-template-columns: 98px 98px 98px;
    column-gap: 11px;
    margin-top: 10px;
    & li {
      width: 98px;
      & .pic-model {
        position: relative;
        width: 98px;
        height: 73px;
        margin-bottom: 4px;
        & .pic {
          display: block;
          width: 100%;
          height: 100%;
        }
        & .pic-play-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          height: 30px;
          width: 30px;
        }
      }
    }
  }
}
</style>
